import React from 'react';
const BUG_REPORT_EMAIL = 'squadverse2025@gmail.com';
const LIFE_BEYOND_FOOTBALL_URL = 'https://youtu.be/7d16CpWp-ok?si=sBTLHEIArpM35fjo';
const ORPHAN_SPONSOR_URL = 'https://www.osflondon.org.uk/';

function buildBugReportHref() {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const screenSize = typeof window !== 'undefined'
    ? `${window.innerWidth}x${window.innerHeight}`
    : '';

  const subject = `Squadverse bug report${pageUrl ? ` - ${pageUrl}` : ''}`;
  const body = [
    'What went wrong?',
    '',
    'What were you trying to do?',
    '',
    'Steps to reproduce:',
    '1. ',
    '2. ',
    '3. ',
    '',
    'Expected result:',
    '',
    'Actual result:',
    '',
    'Context:',
    `Page: ${pageUrl}`,
    `Screen: ${screenSize}`,
    `Browser: ${userAgent}`
  ].join('\n');

  return `mailto:${BUG_REPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export default function BugReportButton() {
  const [href, setHref] = React.useState(() => `mailto:${BUG_REPORT_EMAIL}`);
  const [isCompact, setIsCompact] = React.useState(() => (
    typeof window !== 'undefined' ? window.innerWidth <= 767 : false
  ));

  React.useEffect(() => {
    setHref(buildBugReportHref());
  }, []);

  React.useEffect(() => {
    const updateVisibility = () => {
      const compact = window.innerWidth <= 767;
      setIsCompact(compact);
    };

    updateVisibility();
    window.addEventListener('resize', updateVisibility);
    return () => window.removeEventListener('resize', updateVisibility);
  }, []);

  const buttonBaseStyle = {
    minHeight: isCompact ? 44 : 36,
    minWidth: 0,
    maxWidth: '100%',
    padding: isCompact ? '0.4rem 0.3rem' : '0.48rem 0.75rem',
    borderRadius: 'var(--sv2-radius-sm)',
    textDecoration: 'none',
    fontFamily: 'var(--sv2-font)',
    fontSize: isCompact ? 'clamp(0.54rem, 2vw, 0.66rem)' : '0.78rem',
    lineHeight: isCompact ? 1.12 : 1.2,
    fontWeight: 800,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    overflowWrap: 'anywhere',
    wordBreak: 'normal'
  };

  return (
    <div
      className="bug-report-bar"
      style={{
        width: '100%',
        position: 'static',
        padding: isCompact
          ? '0.55rem 0.5rem calc(0.55rem + env(safe-area-inset-bottom))'
          : '0.55rem 1rem calc(0.55rem + env(safe-area-inset-bottom))',
        boxSizing: 'border-box',
        background: 'rgba(15, 23, 42, 0.72)',
        borderTop: '1px solid rgba(148, 163, 184, 0.12)',
        display: 'grid',
        gridTemplateColumns: isCompact ? 'repeat(3, minmax(0, 1fr))' : 'repeat(3, max-content)',
        justifyContent: 'center',
        alignItems: 'stretch',
        gap: isCompact ? 6 : 8
      }}
    >
      <a
        href={href}
        aria-label="Report a bug"
        style={{
          ...buttonBaseStyle,
          border: '1px solid rgba(148, 163, 184, 0.28)',
          background: 'rgba(15, 23, 42, 0.48)',
          color: '#cbd5e1'
        }}
      >
        Report Bug
      </a>
      <a
        href={LIFE_BEYOND_FOOTBALL_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="There is more to life than football, opens in a new tab"
        style={{
          ...buttonBaseStyle,
          border: '1px solid rgba(93, 201, 224, 0.3)',
          borderRadius: isCompact ? 10 : 999,
          background: 'rgba(8, 47, 73, 0.24)',
          color: '#b9e6f0'
        }}
      >
        There is more to life than football! :)
      </a>
      <a
        href={ORPHAN_SPONSOR_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sponsor an Orphan Today, opens in a new tab"
        style={{
          ...buttonBaseStyle,
          border: '1px solid rgba(183, 255, 138, 0.34)',
          borderRadius: isCompact ? 10 : 999,
          background: 'rgba(22, 101, 52, 0.22)',
          color: '#d8f3c6'
        }}
      >
        Sponsor an Orphan Today
      </a>
    </div>
  );
}
